export const SIZE = 'small';
export const COLOR = '#6c757d';
export const TARGET = '_blank';
export const REL = 'noopener';
export const MESSAGE = 'Learn more about TCN';
export const TCN_HELP_PATH = '#cshid=TCN';
export const WIDTH = "0.7em";
export const HEIGHT = "0.7em";
export const FONTSIZE = "1.4em";
